export default __webpack_public_path__ + "static/media/google_ads.1eaed801.png";